import type { ContractAction, ContractCardView } from '../api';

/*
 * Блок «Приглашённые» в карточке договора: какие кнопки показать и что
 * сказать над таблицей (спека 2026-10-06-mail-invites-design.md).
 *
 * Вынесено из экрана, потому что состояний три, а не два: доступа не было
 * вовсе, доступ открыт, доступ закрыт, а приглашённые остались. Последнее и
 * есть причина: блок нужен и после закрытия — держатель должен видеть, кого
 * приглашал и кто входил.
 */

/**
 * Убрать — закрыть доступ одному человеку на всех его устройствах. Войти
 * снова он сможет только по новому приглашению. Закрыть доступ всем — кнопка
 * «Закрыть доступ».
 */
export const REMOVE_HINT =
  'Убрать — закрыть доступ этому человеку на всех его устройствах. ' +
  'Чтобы закрыть доступ всем сразу, нажмите «Закрыть доступ».';

export type GuestBlock = {
  /** Блок вообще показывается. */
  show: boolean;
  /** Что сказать над таблицей у закрытого доступа; у открытого пусто. */
  note: string;
  /**
   * Есть ли смысл убирать человека. У закрытого доступа его нет: войти и так
   * нельзя, и «Убрать» предлагало бы закрыть уже закрытое.
   */
  removable: boolean;
};

export function guestBlock(guest: ContractCardView['guest']): GuestBlock {
  return {
    show: guest.open || guest.guests.length > 0 || guest.invites.length > 0,
    note: guest.open ? '' : 'Доступ закрыт: по приглашениям больше не войти. Ниже — кого приглашали.',
    removable: guest.open,
  };
}

/** Пригласить можно и при открытом доступе — ещё одного человека; закрыть — только открытый. */
export const guestButtons = (actions: ContractAction[], open: boolean): { invite: boolean; close: boolean } => ({
  invite: actions.includes('openGuest'),
  close: actions.includes('closeGuest') && open,
});

/** Те же кнопки у представителя УК (часть 4, режим «внутри»). */
export const ukGuestButtons = (actions: ContractAction[], open: boolean): { invite: boolean; close: boolean } => ({
  invite: actions.includes('openUkGuest'),
  close: actions.includes('closeUkGuest') && open,
});

/** Состояние строки приглашённого словами. */
export const INVITE_STATE: Record<'INVITED' | 'JOINED' | 'REMOVED', string> = {
  INVITED: 'приглашён, не входил',
  JOINED: 'вошёл',
  REMOVED: 'убран',
};
